import React from 'react';

function EmptyState({ title, description, action = null, className = '' }) {
  const classes = ['card', 'page-header', 'stack-sm', className].filter(Boolean).join(' ');

  return (
    <section className={classes}>
      <h1 className="page-title">{title}</h1>
      {description ? <p className="page-subtitle">{description}</p> : null}
      {action}
    </section>
  );
}

export default EmptyState;
